import {
    tabStyle,
    tabsBarStyle,
    tabsStyle,
    viewToggleButtonStyle,
    viewToggleStyle,
} from "../styles/administrationStyles";

export function renderTabs(view) {
    const { activeSection, residentViewMode, setActiveSection, setResidentViewMode } = view;
    return (
    <div style={tabsBarStyle}>
        <div role="tablist" aria-label="Vues administration" style={tabsStyle}>
            <button
                type="button"
                role="tab"
                aria-selected={activeSection === "residents"}
                onClick={() => setActiveSection("residents")}
                style={tabStyle(activeSection === "residents")}
            >
                Collectivités
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={activeSection === "credits"}
                onClick={() => setActiveSection("credits")}
                style={tabStyle(activeSection === "credits")}
            >
                Crédit EHPADs
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={activeSection === "guardians"}
                onClick={() => setActiveSection("guardians")}
                style={tabStyle(activeSection === "guardians")}
            >
                Tuteur Curateur
            </button>
        </div>
        {activeSection === "residents" && (
            <div role="group" aria-label="Mode d'affichage" style={viewToggleStyle}>
                <button
                    type="button"
                    aria-label="Affichage horizontal"
                    aria-pressed={residentViewMode === "horizontal"}
                    title="Affichage horizontal"
                    onClick={() => setResidentViewMode("horizontal")}
                    style={viewToggleButtonStyle(residentViewMode === "horizontal")}
                >
                    <span aria-hidden="true">▦</span>
                </button>
                <button
                    type="button"
                    aria-label="Affichage vertical"
                    aria-pressed={residentViewMode === "vertical"}
                    title="Affichage vertical"
                    onClick={() => setResidentViewMode("vertical")}
                    style={viewToggleButtonStyle(residentViewMode === "vertical")}
                >
                    <span aria-hidden="true">▤</span>
                </button>
            </div>
        )}
    </div>
    );
}
